module.exports = __webpack_public_path__ + "static/media/thankyou.1655f3f3.svg";